"use client"

import { OneTagScript } from "@/components/pixel-scripts/one-tag-scripts/one-tag-script"
import { usePixelInjectionPermissionPsIta } from "@/hooks/use-pixel-injection-permission"

export function OnetagSignupStartPixelScriptPS() {
  const canInjectPixels = usePixelInjectionPermissionPsIta()

  if (!canInjectPixels) return null

  return <OneTagScript segmentId="117054" scriptId="DT9-signup-start-ps" />
}
